<template>
  <div class="product" @click="showProductDetail(product)">
    <div class="card-image-top">
      <img v-if="product.cover" :src="product.cover" alt="" />
      <img v-else src="@/assets/img/pexels-photo-106399.jpeg" alt="" />
      <div
        class="available-status"
        @click.stop="filterByState(product.state_id)"
        :style="{ 'background-color': product.state_color }"
      >
        <img src="@/assets/icons/bag-2.svg" alt="" />
        <span>{{ product.state_name }}</span>
      </div>
    </div>
    <div class="card-body">
      <p class="name">{{ product.name }}</p>
      <div class="price">
        <span>Giá: </span>
        <span v-if="product.price">{{ Number(product.price).toLocaleString() }} VND</span>
        <span v-else>Liên hệ</span>
      </div>
      <div class="brand" @click.stop="filterByBrand(product.brand_id)">
        <!-- <img v-if="product.brand_icon" height="25px" width="auto" :src="product.iconBrand" alt="" />
        <img v-else src="@/assets/img/chanel.png" alt="" /> -->
        <span>{{ product.brand_name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("publicStoreModule");

import { ShowCategory as ApiShowCategory } from "@/api/categories";
import { ShowBrand as ApiShowBrand } from "@/api/brands";
import { ShowState as ApiShowState } from "@/api/states";

export default {
  props: {
    product: Object,
  },
  methods: {
    ...mapActions(["getProducts", "getProduct"]),
    showProductDetail(product) {
      this.$router.push({
        name: "front.product.detail",
        params: { id: product.id },
      });
      this.getProduct(this.product.id);
    },
    filterByBrand(brand_id) {
      const params = { filter: { brand_id: brand_id }, page: 1 };
      this.getProducts(params);
      ApiShowBrand({ id: brand_id })
        .then((response) => {
          this.$router.push({ name: "front.home.brand", params: { id: brand_id, params: params, name: response.data.name } }).catch(() => { });
        })
        .catch(() => {});
    },
    filterByState(state_id) {
      const params = { filter: { state_id: state_id }, page: 1 };
      this.getProducts(params);
      ApiShowState({ id: state_id })
        .then((response) => {
          this.$router.push({ name: "front.home.state", params: { id: state_id, params: params, name: response.data.name } }).catch(() => { });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="scss">
.product {
  width: 100%;
  border-radius: 20px;
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  .card-image-top {
    width: 100%;
    height: 266px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: 0.2s ease-in;
      &:hover {
        transform: scale(1.1);
      }
    }
    .available-status {
      position: absolute;
      bottom: 22px;
      left: 19px;
      padding: 7px;
      border-radius: 100px;
      width: 142px;
      background-color: #8f8f8f;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 12px;
      img {
        height: 20px;
        width: auto;
        margin-right: 8px;
      }
      &.order {
        background-color: rgb(8, 175, 44);
        color: #fff;
      }
      span {
        line-height: 20px;
        transform: translateY(3px);
      }
    }
  }
  .card-body {
    padding: 30px 20px;
    p {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      height: 46px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #000;
      margin-bottom: 0;
    }
    .price {
      margin-bottom: 25px;
      span {
        font-size: 14px;
      }
      span:nth-child(1) {
        display: inline-block;
        margin-right: 15px;
        font-weight: bold;
      }
      span:nth-child(2) {
        color: rgb(241, 143, 143);
      }
    }
    .brand {
      display: flex;
      align-items: center;
      img {
        height: 24px;
        width: auto;
        margin-right: 10px;
      }
      span {
        color: #000;
        font-weight: bold;
      }
    }
  }
}
</style>
